import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { OwcEditableDropdown, OwcListItem } from "@one/react";

const InputSelectType = ({ value, onHandleChange }) => {
  const { bookingAddReason } = useSelector((state) => state.bookingAdmin);
  const containerRef = useRef(null);
  const handleChange = (selectedValue) => {
    onHandleChange(selectedValue);
  };

  // owc-list-item renders its selected state from the `selected` ATTRIBUTE, not
  // from the property. The @one/react wrapper assigns JSX props as properties
  useEffect(() => {
    const items = containerRef.current?.querySelectorAll("owc-list-item");
    if (!items?.length) return;

    items.forEach((item) => {
      const isSelected = Boolean(value) && (item.textContent || "").trim() === value;
      if (isSelected) {
        item.setAttribute("selected", "");
      } else {
        item.removeAttribute("selected");
      }
    });
  }, [value, bookingAddReason]);
  return (
    <>
      <div
        ref={containerRef}
        style={{
          marginTop: "20px",
        }}
      >
        <OwcEditableDropdown
          label={`Select reason *`}
          style={{ width: "100%" }}
          value={value || null}
          name="bookingAddReason"
          required
          testidprefix="action-data"
          data-testid="Selectreason"
          onSelectChange={(selectedValue) => {
            const selectedIndex = selectedValue?.detail;
            const selectedItem =
              selectedIndex === null || selectedIndex === undefined
                ? null
                : bookingAddReason?.[selectedIndex];
            handleChange(selectedItem ? selectedItem.configText : null);
          }}
        >
          {bookingAddReason?.map((item) => {
            const option = item.configText;
            return (
              <OwcListItem value={option} key={option}>
                {option}
              </OwcListItem>
            );
          })}
        </OwcEditableDropdown>
      </div>
    </>
  );
};

export default InputSelectType;
